// src/services/help.js
import http from "../lib/http";

/**
 * Get all help center complaints for logged in customer
 */
export const getHelpCenterComplaints = async (params = {}) => {
  const response = await http.get("/api/customer/help-center", { params });
  return response.data;
};

/**
 * Create new help center complaint
 * Required fields:
 * - complain_type
 * - issue
 */
export const submitHelpCenterComplaint = async ({ complain_type, issue }) => {
  if (!complain_type || !issue) {
    throw new Error("complain_type and issue are required");
  }

  const payload = {
    complain_type,
    issue,
  };

  const response = await http.post("/api/customer/help-center", payload);
  return response.data;
};

/**
 * Get single complaint by id
 * Use this only if your backend supports:
 * GET /api/customer/help-center/:id
 */
export const getHelpCenterComplaintById = async (id) => {
  const response = await http.get(`/api/customer/help-center/${id}`);
  return response.data;
};